/* TO IMPLEMENT:
**[color]: color of the link (blue, darkestGray, white)
**[padding]: the amount of padding you'd like around the link (0, 5, 10, 15, 20)
**[link]: href of the link

<link-element color="blue" link="/product/6551" padding="10">
	<span slot>Shop <span class="visually-hidden"> the Javalin Pen</span> Now</span>
</link-element>
*/


class LinkElement extends HTMLElement {
	constructor() {
		super();
	}
	
	static get observedAttributes() {
		return ['color', 'link', 'padding'];
	}
	
	get color() {
		return this.getAttribute('color') || "blue";
	}
	
	set color(value) {
		this.setAttribute('color', value);
	}
	
	get padding() {
		return this.getAttribute('padding') || "0";
	}
	
	set padding(value) {
		this.setAttribute('padding', value);
	}
	
	get link() {
		return this.getAttribute('link') || "#";
	}
	
	set link(value) {
		this.setAttribute('link', value);
	}
	
	connectedCallback() {
		//create the "stylesheet"
		const style = document.createElement("style");
		style.textContent = `
			:host([padding="5"]) a{ padding: 0.3125rem; }
			:host([padding="10"]) a{ padding: 0.625rem; }
			:host([padding="15"]) a{ padding: 0.9375rem; }
			:host([padding="20"]) a{ padding: 1.25rem; }
			:host a { display: inherit; }
			
			:host a.noLine,
			:host a.noLine:link,
			:host a.noLine:visited,
			:host a.noLine:hover,
			:host a.noLine:active{
				text-decoration: none;
			}
			
			:host([color="blue"]) a,
			:host([color="blue"]) a:link,
			:host([color="blue"]) a:visited{
				color: var(--blue); 
			} 
            		:host([color="blue"]) a:focus,
            		:host([color="blue"]) a:hover{
				color: var(--dkRed); 
			}
			:host([color="blue"]) a:active{
				color: var(--blue); 
			} 
			
			:host([color="darkestGray"]) a,
			:host([color="darkestGray"]) a:link,
			:host([color="darkestGray"]) a:visited{
				color: var(--darkestGray); 
			} 
            		:host([color="darkestGray"]) a:focus,
            		:host([color="darkestGray"]) a:hover{
				color: var(--blue); 
			}
			:host([color="darkestGray"]) a:active{
				color: var(--darkestGray); 
			} 
			
			:host([color="white"]) a,
			:host([color="white"]) a:link,
			:host([color="white"]) a:visited,
			:host([color="white"]) a:hover,
			:host([color="white"]) a:active,
			:host([color="white"]) a:focus{
				color: var(--white); 
			}
			
			:host a:focus,
			:host a:active,
			:host a:focus-visible{
            			outline: 0;
				-moz-box-shadow: var(--focusShadow) var(--blue);
				-webkit-box-shadow: var(--focusShadow) var(--blue);
				box-shadow: var(--focusShadow) var(--blue);
            		}
		`;
		
		const linkTemplate = document.createElement("template");
		linkTemplate.innerHTML = `
			<a href="${this.link}"><slot></slot></a>
		`;

		this._shadowRoot = this.attachShadow({ mode: "open" });
		this._shadowRoot.appendChild(style);
		this._shadowRoot.appendChild(linkTemplate.content.cloneNode(true));
		
		const linkEl = this._shadowRoot.querySelector("a");
		linkEl.addEventListener("click", () => { linkEl.focus(); });
	}
	
	/*disconnectedCallback() {
		//this.link.removeEventListener('click', this.keepFocus);
	}
	
	keepFocus(){
		this.link.focus();
	}*/
	
	attributeChangedCallback(attrName, oldValue, newValue) {
		if (newValue !== oldValue) {
			switch (attrName) {
				case 'color':
				case 'link':
				case 'padding':
					this[attrName] = this.getAttribute(attrName);
					break;
			}
		}
	}
}

customElements.define('link-element', LinkElement);